var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-file-input',{attrs:{"accept":".csv","show-size":"","label":"File input","hide-details":""},on:{"change":_vm.fileChanged}})
}
var staticRenderFns = []

export { render, staticRenderFns }